import React from 'react';
import ReactECharts from 'echarts-for-react';

const HeatMap = ({ item }) => {
  const { xaxis_values, yaxis_values, zaxis_values } = item.data;

  const data = zaxis_values.flatMap((sublist, sublistIndex) =>
    sublist.map((value, valueIndex) => [valueIndex, sublistIndex, value])
  );

  const options = {
    title: {
      text: item.title,
      textStyle: {
        fontSize: 14,
      },
      left: 'center',
    },
    tooltip: {
      position: 'top',
      formatter(params) {
        return `${item.xaxis_name}: ${params.value[0]}<br>${item.yaxis_name}: ${params.value[1]}<br>${item.zaxis_name}: ${params.value[2]}`;
      },
    },
    grid: {
      height: '65%',
      width: '75%',
      top: '15%',
      left: 'center',
    },
    xAxis: {
      type: 'category',
      data: xaxis_values,
      name: item.xaxis_name,
      nameTextStyle: {
        fontSize: 12,
      },
      splitArea: {
        show: true,
      },
      nameGap: 30,
      nameLocation: 'middle',
    },
    yAxis: {
      type: 'category',
      data: yaxis_values,
      name: item.yaxis_name,
      nameTextStyle: {
        fontSize: 12,
      },
      splitArea: {
        show: true,
      },
      //   nameGap: 40,
      //   nameLocation: 'middle',
    },
    visualMap: {
      min: 0,
      max: 100,
      calculable: true,
      orient: 'vertical',
      top: 'center',
      right: '0',
      color: ['#d94e5d', '#eac736', '#50a3ba'], // Custom colors
    },
    series: [
      {
        name: 'Punch Card',
        type: 'heatmap',
        data,
        label: {
          show: true,
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    ],
  };

  return (
    <ReactECharts
      option={options}
      style={{ width: '550px', height: '350px' }}
      opts={{ renderer: 'svg' }} // Use 'canvas' for better performance
    />
  );
};

export default HeatMap;
